<template>
    <div class="container" v-if="loaded">
        <Card v-if="notifications.meta.total <= 0">
            <Empty :icon="'fa-exclamation-circle'"></Empty>
        </Card>
        <Card v-else>
            <template #header>
                <h2 class="mb-0">{{$t('notification.all')}}</h2>
            </template>
            <template v-if="true">
                <div class="list-group list-group-flush">
                    <div v-for="notification in notifications.data" :key="notification.id">
                        <a
                            @click="redirectToLesson(notification.id, notification.planId, notification.lessonId)"
                            :class="notification.read ? '' : 'nch--read'"
                            class="list-group-item list-group-item-action"
                        >
                            <div class="row align-items-center">
                                <div class="col-auto">
                                    <span :style="{'color': notification.settings.color}">
                                        <i
                                            :class="checkIcon(notification.type)" class="mdi ni-2x"
                                        ></i>
                                    </span>
                                </div>
                                <div class="col ml--2">
                                    <div class="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h4
                                                class="mb-0 text-sm"
                                            >{{notification.translation.name}}</h4>
                                        </div>
                                    </div>
                                    <p class="text-sm mb-0">{{notification.translation.body}}</p>
                                    <p class="text-sm mb-0 text-right text-muted">
                                        {{$moment(notification.created).format('HH:mm DD/MM/YYYY')}}
                                    </p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </template>
            <template #footer>
                <base-pagination
                    class="mb-0"
                    v-if="notifications.meta.total > 10"
                    :page-count="notifications.meta.last_page"
                    v-model="pagination.current_page"
                    @input="onChangePage"
                    align="center"
                    type="#525F7F"
                ></base-pagination>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from '../argon/components/Cards/Card';
import Empty from '../components/Common/Empty';
import BasePagination from '../argon/components/BasePagination';

export default {
    name: 'NotificationIndex',

    components: {
        Card,
        Empty,
        BasePagination,
    },

    props: {
        color: Object,
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            loaded: false,
            search: '',
            filter: '',
            pagination: {
                current_page: 1,
                order: 'DESC',
                column: 'created_at',
                per_page: 10,
                page: 1,
            },
        };
    },

    computed: {
        notifications() {
            return this.$store.getters.LOADED_NOTIFICATIONS;
        },
    },

    methods: {
        getDataFromApi() {
            this.$store
                .dispatch('LOAD_NOTIFICATIONS', {
                    page: this.pagination.page,
                    order: this.pagination.order,
                    column: this.pagination.column,
                    per_page: this.pagination.per_page,
                    search: this.search,
                    filter: this.filter,
                    user_id: this.user.id,
                })
                .then(() => {
                    this.loaded = true;
                });
        },

        onChangePage(page) {
            this.pagination.page = page;
            this.getDataFromApi();
        },

        async redirectToLesson(notificationId, planId, lessonId) {
            this.markRead(notificationId);

            if (lessonId) {
                return window.axios
                    .get(`/api/plan/${planId}/redirect/lesson/${lessonId}`)
                    .then((res) => {
                        if (res.data.redirectLink === '') {
                            window.location.href = '/app/plan/'+ planId + res.data.originalLink;
                        } else {
                            window.location.href = '/app/plan/'+ planId + res.data.redirectLink;
                        }
                    })
                    .catch(err => err);
            }

            // Caso não tenha id da aula, significa que não existe uma aula dentro do
            // módulo que foi vinculado ao plano, então redireciona para o plano
            window.location.href = '/app/plan/'+ planId;
        },

        markRead(id) {
            this.$store.dispatch('SET_NOTIFICATION_READ', id);
        },

        checkIcon(type) {
            switch (type) {
            case 'APP_TICKET_REPLY':
                return 'mdi-ticket-confirmation';

            default:
                return 'mdi-alert-circle-outline';
            }
        },
    },

    mounted() {
        this.getDataFromApi();
    },
};
</script>

<style>
.nch--read {
    background: #edf2fa;
}
.nch--read:hover {
    background: #f7f9fd;
}
</style>
